<form lin-layout-form [formGroup]="form" (ngSubmit)="duplicate()">
  <lin-form-label required
    >{{ (isReminderContext ? 'DIALOGS.DUPLICATE_DIALOG.ADD_SAME_SERVICE_REMINDER' : 'DIALOGS.DUPLICATE_DIALOG.ADD_SAME_DOCUMENT') |
    translate }}</lin-form-label
  >
  <mat-form-field>
    <mat-select formControlName="scope">
      @if (!isVehicleScope) {
      <mat-option value="">{{ 'DIALOGS.DUPLICATE_DIALOG.ALL_ASSETS' | translate }}</mat-option>
      <mat-option [value]="DuplicateDialogScope.Assets">{{ 'DIALOGS.DUPLICATE_DIALOG.ASSETS' | translate }}</mat-option>
      } @if (isVehicleScope) {
      <mat-option value="">{{ 'DIALOGS.DUPLICATE_DIALOG.ALL_VEHICLES' | translate }}</mat-option>
      <mat-option [value]="DuplicateDialogScope.Vehicles">{{ 'DIALOGS.DUPLICATE_DIALOG.VEHICLES' | translate }}</mat-option>
      }
      <mat-option [value]="DuplicateDialogScope.Groups"> {{ 'DIALOGS.DUPLICATE_DIALOG.GROUPS' | translate }} </mat-option>
      <mat-option [value]="DuplicateDialogScope.Depots"> {{ 'DIALOGS.DUPLICATE_DIALOG.DEPOT' | translate }} </mat-option>
    </mat-select>
  </mat-form-field>

  @if (form.controls.scope.value) { @switch (form.controls.scope.value) { @case (DuplicateDialogScope.Assets) {
  <lin-form-label required>{{ 'DIALOGS.DUPLICATE_DIALOG.ASSETS' | translate }}</lin-form-label>
  <lin-form-field>
    <lin-form-checkbox-search-list formControlName="duplicateDialogScope" [items]="assetList" [matchWith]="matchAssetWith">
      <span *ng="let asset; let search = search" innerHTML="{{ asset.idNumber | highlight: search }} ({{ asset.name }})"></span>
    </lin-form-checkbox-search-list>
  </lin-form-field>
  } @case (DuplicateDialogScope.Vehicles) {
  <lin-form-label required>{{ 'DIALOGS.DUPLICATE_DIALOG.VEHICLES' | translate }}</lin-form-label>
  <lin-form-field>
    <lin-form-checkbox-search-list formControlName="duplicateDialogScope" [items]="vehicleList" [matchWith]="matchVehicleWith">
      <span *ng="let vehicle; let search = search" innerHTML="{{ vehicle.regNo | highlight: search }} ({{ vehicle.defaultLabel }})"></span>
    </lin-form-checkbox-search-list>
  </lin-form-field>
  } @case (DuplicateDialogScope.Depots) {
  <lin-form-label required>{{ 'DIALOGS.DUPLICATE_DIALOG.DEPOT' | translate }}</lin-form-label>
  <lin-form-field>
    <lin-form-checkbox-search-list formControlName="duplicateDialogScope" [items]="depotList" [matchWith]="matchDepotWith">
      <span *ng="let depot; let search = search" [innerHTML]="depot.name | highlight: search"></span>
    </lin-form-checkbox-search-list>
  </lin-form-field>
  } @case (DuplicateDialogScope.Groups) {
  <lin-form-label required>{{ 'DIALOGS.DUPLICATE_DIALOG.GROUPS' | translate }}</lin-form-label>
  <lin-form-field>
    <lin-form-checkbox-search-list formControlName="duplicateDialogScope" [items]="groupList" [matchWith]="matchGroupWith">
      <span *ng="let group; let search = search" [innerHTML]="group.name | highlight: search"></span>
    </lin-form-checkbox-search-list>
  </lin-form-field>
  } } } @else {
  <div class="empty-content"></div>
  }

  <lin-layout-form-toolbar class="form-toolbar">
    <lin-form-submit-button>{{ 'DIALOGS.DUPLICATE_DIALOG.DUPLICATE' | translate }}</lin-form-submit-button>
  </lin-layout-form-toolbar>
</form>
